<script>
import MarketingConsents from '@phoenix/mixins/components/form/MarketingConsents';
import FormGroup from '@maison/components/form/FormGroup.vue';
import CheckboxListField from '@maison/components/form/fields/CheckboxListField';

export default {
  components: {
    FormGroup,
    CheckboxListField,
  },

  mixins: [MarketingConsents],
};
</script>

<template>
  <form-group :attrs="field" :show-label="false" data-cy="marketingConsents" v-bind="formGroupProps">
    <checkbox-list-field v-model="value" v-bind="checkboxListProps" />
  </form-group>
</template>
